import {
  CustomerDetails,
  CustomerTelephoneDetails,
} from '@domgen/dgx-fe-common';

export interface CheckoutCustomerDetails
  extends Omit<CustomerDetails, 'telephoneDetails'> {
  telephone?: CustomerTelephoneDetails;
}
